import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="contacts--drawer-reset"
//
// React's Invoicing drawers (CONEK-8263) throw unsaved edits away on cancel /
// close, so reopening one shows the saved values again. The pristine fields are
// server-rendered into a <template> (inert, so nothing in it connects); on
// `drawer:close` the live fields are swapped for a fresh copy. It also runs on
// turbo:before-cache, so a Back restoration never brings dirty values back —
// the global handler still re-hides the drawer itself (CONEK-6282). Dispatches
// `reset` so sibling controllers can recompute (e.g. contacts--submit-gate).
export default class extends Controller {
  static targets = ["template", "container"]

  reset() {
    this.containerTarget.replaceChildren(
      this.templateTarget.content.cloneNode(true),
    )
    this.dispatch("reset")
  }
}
